import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './AppIcon';
import Button from './ui/Button';

const NotificationCenter = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: 'appointment',
      title: 'Upcoming Session',
      message: 'Your session with Dr. Sarah Johnson starts in 30 minutes',
      time: '2025-12-04T06:30:00',
      unread: true,
    },
    {
      id: 2,
      type: 'availability',
      title: 'Helper Available',
      message: 'Dr. Michael Chen has new availability this week',
      time: '2025-12-04T05:15:00',
      unread: true,
    },
    {
      id: 3,
      type: 'system',
      title: 'Profile Updated',
      message: 'Your helper profile has been successfully verified',
      time: '2025-12-03T14:20:00',
      unread: false,
    },
  ]);

  const unreadCount = notifications?.filter((n) => n?.unread)?.length;

  const toggleNotifications = () => {
    setIsOpen(!isOpen);
  };

  const markAsRead = (id) => {
    setNotifications(notifications?.map((n) =>
      n?.id === id ? { ...n, unread: false } : n
    ));
  };

  const markAllAsRead = () => {
    setNotifications(notifications?.map((n) => ({ ...n, unread: false })));
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'appointment':
        return 'Calendar';
      case 'availability':
        return 'UserCheck';
      case 'system':
        return 'Bell';
      default:
        return 'Bell';
    }
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    return `${diffDays}d ago`;
  };

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="icon"
        iconName="Bell"
        onClick={toggleNotifications}
        className="relative"
      >
        {unreadCount > 0 && (
          <span className="notification-badge">{unreadCount}</span>
        )}
      </Button>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-[750]"
            onClick={() => setIsOpen(false)}
          />
          <div className="notification-dropdown">
            <div className="notification-header">
              <h3 className="text-base font-semibold">Notifications</h3>
              {unreadCount > 0 && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={markAllAsRead}
                  className="text-xs"
                >
                  Mark all read
                </Button>
              )}
            </div>

            <div className="notification-list">
              {notifications?.length === 0 ? (
                <div className="px-4 py-8 text-center text-muted-foreground">
                  <Icon name="Bell" size={32} className="mx-auto mb-2 opacity-50" />
                  <p className="text-sm">No notifications</p>
                </div>
              ) : (
                notifications?.map((notification) => (
                  <div
                    key={notification?.id}
                    className={`notification-item ${notification?.unread ? 'unread' : ''}`}
                    onClick={() => markAsRead(notification?.id)}
                  >
                    <div className="flex items-start gap-3">
                      <div className="mt-1">
                        <Icon
                          name={getNotificationIcon(notification?.type)}
                          size={20}
                          className="text-primary"
                        />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between gap-2">
                          <p className="text-sm font-medium text-foreground">
                            {notification?.title}
                          </p>
                          {notification?.unread && (
                            <div className="w-2 h-2 rounded-full bg-primary flex-shrink-0 mt-1" />
                          )}
                        </div>
                        <p className="text-sm text-muted-foreground mt-1">
                          {notification?.message}
                        </p>
                        <p className="text-xs text-muted-foreground mt-1">
                          {formatTime(notification?.time)}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>

            <div className="notification-footer">
              <Button
                variant="ghost"
                size="sm"
                fullWidth
                onClick={() => {
                  setIsOpen(false);
                  navigate('/personal-dashboard');
                }}
              >
                View All Notifications
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationCenter;